module.exports = __webpack_public_path__ + "static/media/default.22f28e42.svg";